__turbopack_context__.v({
  "className": "barlow_a4499686-module__rcM2Fq__className",
  "variable": "barlow_a4499686-module__rcM2Fq__variable",
});
